module.exports = __webpack_public_path__ + "media/images/icons/to-watch-2497e5c3fd162ec9c49ef60ba36141fc.svg";